import { LeftSidebarView, ViewBody } from 'components/Sidebar'
import { Formik } from 'formik'
import React, { useCallback, useMemo } from 'react'
import {
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import {
  ButtonGroup,
} from 'react-bootstrap'
import Button from 'components/Button'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import requestChangeDocumentName from 'store/sagas/requestChangeDocumentName'
import { useDispatch } from 'react-redux'
import { getFileName, getExtension } from 'utils/documents'

type Props = LeftSidebarProps & {
  documentSourceId: number
  url: string
  name: string
  onRename: (args: { promise: Promise<any>, documentSourceId: number, url: string, name: string, newName: string }) => void
}

const DocumentRename: React.FC<Props> = ({
  leftSidebar,
  documentSourceId,
  url,
  name,
  onRename
}) => {
  const dispatch = useDispatch()

  const close = useCallback(() => {
    leftSidebar.pop()
  }, [])

  const fileName = useMemo(() => getFileName(name), [name])
  const extension = useMemo(() => getExtension(name), [name])

  return (
    <LeftSidebarView
      title={<FormattedMessage id='DOCUMENT_RENAME_HEADER' />}
    >
      <ViewBody>
        <Formik
          initialValues={{
            name: fileName
          }}
          onSubmit={(values) => {
            const newName = `${values.name}${extension ? `.${extension}` : ''}`

            if (newName !== name) {
              const promise: any = dispatch(requestChangeDocumentName({
                documentSourceId,
                url,
                name: newName,
              }))

              onRename?.({
                promise,
                documentSourceId,
                url,
                name,
                newName,
              })
            }

            close()
          }}
        >
          {({ values, handleSubmit, handleChange, handleBlur, isSubmitting }) =>
            <form onSubmit={handleSubmit}>
              <FormGroup>
                <ControlLabel><FormattedMessage id='DOCUMENT_RENAME_NEW_NAME' /></ControlLabel>
                <FormControl
                  autoFocus
                  type='text'
                  name='name'
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </FormGroup>
              <ButtonGroup>
                <Button
                  type='submit'
                  bsStyle='primary'
                  disabled={isSubmitting || !values.name}
                >
                  <FormattedMessage id='DOCUMENT_RENAME' />
                </Button>
                <Button
                  onClick={close}
                >
                  <FormattedMessage id='CANCEL' />
                </Button>
              </ButtonGroup>
            </form>
          }
        </Formik>
      </ViewBody>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(DocumentRename)
